import { createContext, useContext } from 'react';

const HistoricalScopePresentationContext = createContext(false);

export const HistoricalScopePresentationProvider = HistoricalScopePresentationContext.Provider;

export const useIsHistoricalScopePresentation = () => useContext(HistoricalScopePresentationContext);
